<template>
  <!-- Back to top button -->
  <a
    id="backToTop"
    href="javascript:;"
    class="btn btn-green min-w-50 back-to-top"
    ><i class="fa fa-angle-double-up"></i
  ></a>
</template>

<script>
/* eslint-disable */
export default {
  name: "Backtotop",
  data() {
    return {};
  },
  created() {
    $(document).ready(function() {
      $("#backToTop").click(function() {
        $("html, body").animate({ scrollTop: 0 }, 1500, "easeInOutExpo");
        return false;
      });
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/Backtotop.vue